var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 6.14942C0.5 5.04485 1.39543 4.14941 2.5 4.14941H18.5C19.6046 4.14941 20.5 5.04484 20.5 6.14941V16.3161C20.5 17.4206 19.6046 18.3161 18.5 18.3161H2.5C1.39543 18.3161 0.5 17.4207 0.5 16.3161V6.14942Z",
    stroke: "#979797",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.92131 5.45228C1.41709 4.99008 1.74409 4.14941 2.4281 4.14941H18.5719C19.2559 4.14941 19.5829 4.99008 19.0787 5.45228L12.5272 11.4578C11.3802 12.5092 9.61979 12.5092 8.47283 11.4578L1.92131 5.45228Z",
    stroke: "#979797",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.400bfd0c903e2349fbe091051070c0c2.svg";
export { ForwardRef as ReactComponent };